export const COLLECTION_SETTINGS_PATH = '/billing/collection-settings';

export const collectionPoliciesPath = () => `${COLLECTION_SETTINGS_PATH}/policies`;

export const collectionPolicyNewPath = () => `${collectionPoliciesPath()}/new`;

export const collectionPolicyEditPath = (policyId: string) => `${collectionPoliciesPath()}/${policyId}/edit`;

export const collectionAgreementsPath = () => `${COLLECTION_SETTINGS_PATH}/agreements`;

export const collectionAgreementViewPath = (agreementId: string) => `${collectionAgreementsPath()}/${agreementId}`;

export const collectionAgreementEditPath = (agreementId: string) => `${collectionAgreementsPath()}/${agreementId}/edit`;
